import React, { useContext } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Header from "./cmp/header";
import MySidebar from "./cmp/nav";
import Login from "./cmp/login";
import Dashboard from "./cmp/dashboard";
import AdminProfile from "./cmp/profile";
import Users from "./cmp/users";
import UserDetails from "./cmp/users_detail";
import Library from "./cmp/library";
import AddCategory from "./cmp/add_category";
import Videos from "./cmp/videos";
import UploadVideos from "./cmp/upload_video";
import PlayVideo from "./cmp/play_video";
import SpecialLibrary from "./cmp/special_library";
import AddProgram from "./cmp/add_program";
import SpecialProgramDetail from "./cmp/special_program_detail";
import Banners from "./cmp/banners";
import AddBanner from "./cmp/add_banner";
import Equipment from "./cmp/equipment";
import AddEquipment from "./cmp/add_equipment";
import Messages from "./cmp/messages";
import Chat from "./cmp/chat";
import SendEmail from "./cmp/send_email";
import SendNotification from "./cmp/send_notification";
import Guides from "./cmp/guides";
import Settings from "./cmp/settings";
import GuideVideos from "./cmp/guide_videos";
import HomeSubscriptions from "./cmp/home_subscriptions";
import HomeProgramsJoined from "./cmp/home_programs_joined";
import HomeProgramSales from "./cmp/home_program_sales";
import ForgotPassword from "./cmp/forgot_password";
import AssignPrograms from "./cmp/assign_programs";
import UserAdminAssignments from "./cmp/user-admin-assignments";
import SubscriptionAd from "./cmp/subscription-ad";
import MergeCats from "./cmp/merge_cats";
import Download from "./cmp/download";
import SettingsPro from "./cmp/settings_pro";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProReferrals from "./cmp/pro_referrals";
import AddCode from "./cmp/AddCode/AddCode";
import CodeList from "./cmp/CodeList/CodeList";
import CodeUsage from "./cmp/CodeUsage/CodeUsage";
import EditCode from "./cmp/EditCode/EditCode";
import DeleteAccount from "./cmp/DeleteAccount/DeleteAccount";
import AuthContextProvider, { AuthContext } from "./context/AuthContext";

const LoginContainer = () => (
  <div>
    <Route path="/login" component={Login} />
  </div>
);

const HomeContainer = () => {
  return (
    <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <Header />
        <div style={{ display: "flex", width: "100%" }}>
          <MySidebar />
          <Route path="/" exact component={Dashboard} />
          <Route path="/profile" exact component={AdminProfile} />
          <Route path="/users" exact component={Users} />
          <Route path="/user-details" exact component={UserDetails} />
          <Route path="/pro-referrals" exact component={ProReferrals} />
          <Route path="/library" exact component={Library} />
          <Route path="/special-library" exact component={SpecialLibrary} />
          <Route path="/add-category" exact component={AddCategory} />
          <Route path="/videos" exact component={Videos} />
          <Route path="/upload-videos" exact component={UploadVideos} />
          <Route path="/play-video" exact component={PlayVideo} />
          <Route path="/add-program" exact component={AddProgram} />
          <Route path="/program-detail" exact component={SpecialProgramDetail} />
          <Route path="/banners" exact component={Banners} />
          <Route path="/add-banner" exact component={AddBanner} />
          <Route path="/equipment" exact component={Equipment} />
          <Route path="/add-equipment" exact component={AddEquipment} />
          <Route path="/messages" exact component={Messages} />
          <Route path="/chat" exact component={Chat} />
          <Route path="/send-email" exact component={SendEmail} />
          <Route path="/send-notification" exact component={SendNotification} />
          <Route path="/guides" exact component={Guides} />
          <Route path="/settings" exact component={Settings} />
          <Route path="/settings-pro" exact component={SettingsPro} />
          <Route path="/guide-videos" exact component={GuideVideos} />
          <Route path="/home-subscriptions" exact component={HomeSubscriptions} />
          <Route path="/home-programs-joined" exact component={HomeProgramsJoined} />
          <Route path="/home-program-sales" exact component={HomeProgramSales} />
          <Route path="/assign-programs" exact component={AssignPrograms} />
          <Route path="/user-admin-assignments" exact component={UserAdminAssignments} />
          <Route path="/subscription-ad" exact component={SubscriptionAd} />
          <Route path="/merge-cats" exact component={MergeCats} />
          {/* <Route path="/download" exact component={Download} /> */}
          <Route path="/add-code" exact component={AddCode} />
          <Route path="/codes" exact component={CodeList} />
          <Route path="/code-usage" exact component={CodeUsage} />
          <Route path="/edit-code" exact component={EditCode} />
          {/* <Route path="/delete-account" exact component={DeleteAccount} /> */}
        </div>
      </div>
    </div>
  );
};

const RouterContainer = () => {
  const { user } = useContext(AuthContext);

  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/(login)" component={LoginContainer} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/index.html" render={() => <Redirect to="/" />} />
          <Route path="/download" exact component={Download} />
          <Route path="/delete-account" exact component={DeleteAccount} />
          {user && <Route component={HomeContainer} />}
          <Route path="*" render={() => <Redirect to="/login" />} />
        </Switch>
        <ToastContainer />
      </div>
    </Router>
  );
};

const App = () => {
  return (
    <AuthContextProvider>
      <RouterContainer />
    </AuthContextProvider>
  );
};
export default App;
